import { countryCodes, unitedStatesTerritories } from '../constants/locale';

export default function isUserInUSOrUSTerritories(userLocation) {
  return (
    userLocation === countryCodes.US || !!unitedStatesTerritories[userLocation]
  );
}
